import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verificacion-documentos',
  templateUrl: './verificacion-documentos.component.html',
  styleUrls: ['./verificacion-documentos.component.css']
})
export class VerificacionDocumentosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
